import { h } from 'preact'
import { isTouchDevice, tagParser, linkParser, proxymedia } from '../../js/modules/utilities.js'
import { useState } from 'preact/hooks'
import style from './shadowStyles_banniere.scss'

export const banniereStyle = style

export const bannierePlaceholder = `
   #postCommande.placeholder,
   #monAutreBannier.placeholder {
      min-height: 355px;
      @media (max-width: 960px) {
         min-height: 423px;
      }
      @media (max-width: 479px) {
         min-height: calc((100vw * (520 / 480)) + 30px);
      }
   }
`

export const Banniere = ({ format, tag, date, title, description, legals, legalNotice, images, URL, textColor, analytics, cacheKey, alt, index }) => {
   title = tagParser(title)
   description = tagParser(description)
   legals = tagParser(legals)
   let adviseTags = {}
   if (analytics.pdbSc === 'adv') {
      adviseTags = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <div class={`banner-wrapper position-relative format-${format}`}>
         <a
            href={URL}
            class={`small-height banniere textcolor-${textColor}`}
            data-testid="banner"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            {...adviseTags}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            data-cache-key={cacheKey}
         >
            <BackgroundImage format={format} images={images} alt={alt} />
            {(tag || date || title || description || legals) && <Content tag={tag} date={date} title={title} description={description} legals={legals} />}
         </a>
         {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} index={index} />}
      </div>
   )
}

const getTagBgColor = (tag) => {
   if (tag && tag.indexOf('[tagwhite]') !== -1) {
      return 'white'
   } else {
      return 'yellow'
   }
}

const getTagText = (tag) => {
   if (tag) {
      tag = tag.replace(/\[.*?\]/g, '')
      return tag
   } else {
      return ''
   }
}

const Content = ({ tag, date, title, description, legals }) => {
   return (
      <div class="wrapper">
         <div class="content">
            {(tag || date) && (
               <div class="top">
                  {tag && <span class={`ob1-tag ${getTagBgColor(tag) === 'white' ? 'ob1-tag-white' : 'ob1-tag-primary'}`}>{getTagText(tag)}</span>}
                  {date && <span class="date">{date}</span>}
               </div>
            )}
            {title && <h3 class="title" dangerouslySetInnerHTML={{ __html: title }}></h3>}
            {description && <p class="description" dangerouslySetInnerHTML={{ __html: description }}></p>}

            {legals && (
               <div class="bottom">
                  <p class="legals" dangerouslySetInnerHTML={{ __html: legals }}></p>
               </div>
            )}
         </div>
      </div>
   )
}

const LegalNotice = ({ showButtonLabel, title, content, background, index = 0 }) => {
   const [legalState, setLegalState] = useState(false)
   const [legalHoverState, setLegalHoverState] = useState(false)

   const toggleLegals = () => {
      setLegalState(!legalState)
      if (legalState === false) {
         pauseCarrousel()
      } else {
         resetCarrousel()
      }
   }

   const showLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(true)
   }

   const hideLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(false)
   }

   const pauseCarrousel = () => {
      const isCarrouselPlaying = document.querySelector('.glide__playpause--pause') ? true : false
      if (isCarrouselPlaying) {
         document.querySelector('.glide__playpause').classList.add('pauseByLegals')
         document.querySelector('.glide__playpause').click()
      }
   }

   const resetCarrousel = () => {
      const isCarrouselPause = document.querySelector('.glide__playpause--play') ? true : false
      if (isCarrouselPause) {
         let isCarrouselPausedByLegal = document.querySelector('.glide__playpause.pauseByLegals') ? true : false
         if (isCarrouselPausedByLegal) {
            document.querySelector('.glide__playpause').click()
            document.querySelector('.glide__playpause').classList.remove('pauseByLegals')
         }
      }
   }

   return (
      <div
         class={`bannerLegalNotice ${legalState ? 'openContent' : ''} ${legalHoverState ? 'isHover' : ''} ${background === 'white' ? 'grey-bg' : 'black-bg'}`}
         onMouseLeave={hideLegals}
      >
         <div id={`legalNoticePanel${index}`} class="contentLegalNotice" aria-hidden={!legalState}>
            <span class="closeLegal" onClick={toggleLegals}>
               &times;
            </span>
            <div class="contentText">
               {title && <div class="legalNoticeTitle" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div>}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onMouseEnter={showLegals}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class="showButton-label">{showButtonLabel}</span>&nbsp;<span class="icon icon-info"></span>
         </span>
      </div>
   )
}

const BackgroundImage = ({ format, images, alt }) => {
   // small: 960x1040
   // medium: 1800x720
   // large: 1440x310
   let balisePicture = (
      <picture>
         <source srcset={`${proxymedia(images.small, 'saveas=webp')}`} media="(max-width: 479px)" />
         <source srcset={`${proxymedia(images.medium, 'saveas=webp')}`} media="(max-width: 959px)" />
         <img class="background-img" src={proxymedia(images.large, 'saveas=webp')} alt={alt} />
      </picture>
   )

   // N-1 TV
   // small: 960x1040
   // medium: 1800x720
   // large: 1200x388
   if (format === '1200x388-960x1040') {
      balisePicture = (
         <picture>
            <source srcset={`${proxymedia(images.small, 'saveas=webp')}`} media="(max-width: 479px)" />
            <source srcset={`${proxymedia(images.medium, 'saveas=webp')}`} media="(max-width: 959px)" />
            <img class="background-img" src={`${proxymedia(images.large, 'crop=960,310,0,39&saveas=webp')}`} alt={alt} />
         </picture>
      )
   }

   return balisePicture
}
